<template>
  <div
    :class="[
      'chart-sm-block',
      'chart-sm-block--' + info.color || '',
      { 'chart-sm-block--hoverable': isHoverable },
      { 'chart-sm-block--active': isActive}
    ]"
    @click="click"
  >
    <div class="chart-sm-block__icon">
      <component :is="IconCompo" />
    </div>
    <div
      v-if="numValue !== null"
      class="chart-sm-block__content">
      <span v-html="numValue" :title="numValue" class="content__value">
        &#8381;
      </span>
      <span class="content__text">
        {{ info.text }}
      </span>
    </div>
    <spinner v-else type="dots" />
    <!-- <button class="chart-sm-block__menu-btn"></button> -->
  </div>
</template>

<script>
import Spinner from "@/manzana_library/components/Widgets/Spinner.vue";
import { fNum } from "@/utils/formatters.js";

export default {
  name: "ChartSmBlock",
  components: {
    Spinner
  },
  props: {
    isHoverable: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    click: {
      type: Function,
      default: () => {}
    },
    info: {
      type: Object,
      default: function() {
        return {
          icon: "growth",
          value: 0,
          text: "",
          measurement: "&#8381",
          color: "blue"
        }
      }
    }
  },
  computed: {
		IconCompo() {
			return () => import(`@/components/Icons/dashboards/${this.info.icon || 'growth'}`);
    },
    numValue() {
      const { measurement, value } = this.info;
      const ruMeasurement = Array.isArray(measurement) ? this.fStr.getRusEnding(value, measurement) : measurement;

      if (value === null) return null;
      return measurement === "%" ? fNum.fullFormat(value, ruMeasurement) : fNum.format(value, ruMeasurement)
    }
  }
}
</script>

<style lang="scss">
@import "@/manzana_library/scss/utils/_variables.scss";

@mixin colorBlock($color) {
  .content__value {
    color: $color;
    white-space: nowrap;
  }
  .chart-sm-block__icon {
    border-color: $color;
    svg {
      fill: $color;
    }
    .stroke-current {
      stroke: $color;
    }
  }
}

.chart-sm-block {
  background: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05), 4px 0px 10px rgba(0, 0, 0, 0.05), -4px 0px 10px rgba(0, 0, 0, 0.05), 0px -4px 10px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  width: 265px;
  height: 65px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 11px 13px;
  &--hoverable {
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &:hover {
       opacity: 0.8;
      //  transform: scale(1.05);
    }
  }
  &--active {
    box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.25);
    transform: scale(1.15,1.15);
    &:hover {
      opacity: 0.8;
    }
  }

  &:first-of-type.chart-sm-block--active {
    transform: scale(1.15,1.15) translate(10px, 0);
  }

  &:last-of-type.chart-sm-block--active {
    transform: scale(1.15,1.15) translate(-20px, 0);
  }

  &--blue {
    @include colorBlock(#00aedf);
  }
  &--violet {
    @include colorBlock(#7370ff);
  }
  &--green {
    @include colorBlock(#00ca64);
  }
  &--orange {
    @include colorBlock(#fc7907);
  }
  &--red {
    @include colorBlock(#ff8373);
  }
  &--yellow {
    @include colorBlock(#ffdA83);
  }

  &__icon {
    border: 1px solid $color_black;
    border-radius: 50%;
    width: 37px;
    height: 37px;
    min-width: 37px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__content {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    overflow: hidden;
  }
  .spinner-dots {
    margin: 0 auto;
  }
  .content {
    &__value {
      font-size: 18px;
      font-weight: 600;
      @include overflow-ellipsis();
    }
    &__text {
      font-size: 13px;
      color: #afafaf;
    }
  }
  &__menu-btn {
    background: url("#{$image-path}three-circle.svg") no-repeat;
    margin-left: auto;
    width: 16px;
    height: 4px;
    padding: 0;
  }
}
</style>
